import { useNavigate, type NavigateOptions } from 'react-router'

import { parseInternalHttpUrl } from './safe-navigation'

/**
 * Returns a guarded React Router navigate callback for runtime-provided internal URLs.
 *
 * Use this for dynamic links that should stay within the current application without a full
 * reload. Use `openExternalHttp` for allowlisted external downloads and `reloadInternal` when a
 * full document reload is required.
 */
export const useSafeNavigate = (): ((raw: unknown, options?: NavigateOptions) => void) => {
    const navigate = useNavigate()

    return (raw: unknown, options?: NavigateOptions): void => {
        const parsed = parseInternalHttpUrl(raw)
        if (!parsed) {
            return
        }

        navigate(`${parsed.pathname}${parsed.search}${parsed.hash}`, options)
    }
}
